import React from 'react';

function Contact() {
  const contactInfo = [
    {
      image: "./assets/img/contact/1.jpg",
      phoneIcon: "./assets/img/icon/phone.svg",
      phone: "+12 608 (3456) 789",
    },
  ];

  return (
    <section
      className="contact-section section-padding fix section-bg2 bg-cover"
      style={{ backgroundImage: `url('./assets/img/contact/bg.png')` }}
    >
      <div className="container">
        <div className="row g-4">
          <div className="col-lg-6">
            <div className="contact-wrapper">
              <div className="section-title">
                <span className="sub-title style-2 wow fadeInUp">
                  Contact Us
                </span>
                <h2 className="wow fadeInUp" data-wow-delay=".3s">
                  Let's Build An Awesome Project Together
                </h2>
              </div>
              {contactInfo.map((info, index) => (
                <div className="contact-thumb wow fadeInUp" key={index}>
                  <img src={info.image} className="ex" alt="Contact" />
                  <h4>
                    <img src={info.phoneIcon} alt="Phone icon" /> {info.phone}
                  </h4>
                </div>
              ))}
            </div>
          </div>
          <div className="col-lg-6">
            <div className="contact-form wow fadeInUp" data-wow-delay=".5s">
              <h3>Fill The Contact Form</h3>
              <p>Feel free to contact with us, we don't spam your email</p>
              <form action="#" method="post">
                <div className="row g-4">
                  <div className="col-6">
                    <div className="form-clt">
                      <input
                        type="text"
                        name="name"
                        id="name"
                        placeholder="Your name"
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-clt">
                      <input
                        type="tel"
                        name="phone"
                        id="phone"
                        placeholder="Phone number"
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-clt">
                      <input
                        type="email"
                        name="email"
                        id="email"
                        placeholder="Email address"
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-clt">
                      <textarea
                        name="message"
                        id="message"
                        placeholder="Write your message"
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-12">
                    <button type="submit" className="theme-btn">
                      Send Message
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;